import { buildTheme, ThemeColors } from "./buildTheme";

// Matches the background baked into the logo image, so the logo blends into the
// header bar instead of reading as a separate tile.
export const HEADER_COLOR = "#12110f";

const COLORS: ThemeColors = {
  accent: "#d40000",
  // Same warm tone as HEADER_COLOR, lifted slightly (equivalent to
  // lighten(HEADER_COLOR, 0.05)) so pages sit just above the header.
  background: "#1e1d1b",
  textPrimary: "#ffffff",
  textSecondary: "#ffffff",
};

export const theme = buildTheme(COLORS);
